/*
  salt&spirit. · ss-cart.js (pliego §4, D7, §11 #15)
  - window.ssQuickAdd(el)   → cajón vacío (E-G12): agrega 1 caja en compra única.
  - window.ssSwapToMix(el)  → E-G04: sustituye la única línea por el MIX con el MISMO selling_plan.
  - SS_DRAWER_AUTOOPEN      → D7: true = Dawn abre el cajón al agregar. false = parche de renderContents sin open().
  Reglas: funciones globales llamadas por onclick (el cajón se re-renderiza por innerHTML), candado __adding,
  sin addEventListener('change'). Tras cada fetch se re-pinta el cajón con las secciones que Dawn declara
  (cart-drawer + cart-icon-bubble) y se publica cartUpdate para los suscriptores de Dawn / ss-subscribe.
*/
(function () {
  if (window.__ssCartReady) return;
  window.__ssCartReady = true;

  var SS_DRAWER_AUTOOPEN = false; /* 29-sep: regla CLAUDE.md, el aviso «✓ agregado · Ver carrito» abre el cajón */
  var __adding = false;
  window.SS_DRAWER_AUTOOPEN = SS_DRAWER_AUTOOPEN;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionIds() {
    var d = getDrawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-icon-bubble'];
  }

  function postJSON(path, body) {
    return fetch(rootUrl() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (e) { j = null; }
        if (!r.ok || !j || (j.status && (j.status >= 400 || j.status === 'bad_request'))) {
          /* 422 de Shopify trae `description` legible; 429/HTML u otro error → mensaje genérico */
          var err = new Error((j && typeof j.description === 'string' && j.description) || '');
          err.data = j;
          err.code = r.status;
          throw err;
        }
        return j;
      });
    });
  }

  function lock(el) {
    if (!el) return;
    el.setAttribute('aria-disabled', 'true');
    el.classList.add('is-loading');
  }

  function unlock(el) {
    if (!el) return;
    el.removeAttribute('aria-disabled');
    el.classList.remove('is-loading');
  }

  function showMsg(el, text) {
    var id = el && el.dataset ? el.dataset.msg : null;
    var box = id ? document.getElementById(id) : null;
    if (!box) return;
    box.textContent = text;
    box.hidden = false;
  }

  function publishUpdate(json) {
    /* PUB_SUB_EVENTS es un `const` global de Dawn (constants.js): no cuelga de window. */
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ss-cart', cartData: json }); } catch (e) { /* sin suscriptores */ }
    }
  }

  /* Re-pinta el cajón con la respuesta que ya trae `sections`. Sin cajón (p. ej. cart_type ≠ drawer): recarga. */
  function paint(json) {
    var d = getDrawer();
    if (d && typeof d.renderContents === 'function' && json && json.sections) {
      d.classList.remove('is-empty');
      d.renderContents(json);
      publishUpdate(json);
      return;
    }
    window.location.reload();
  }

  /* Refresco de rescate si la 2.ª petición falla a medias (el carrito pudo cambiar). */
  function refresh() {
    var ids = sectionIds().join(',');
    return fetch(rootUrl() + 'cart.js?sections=' + encodeURIComponent(ids), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var d = getDrawer();
        if (d) d.classList.toggle('is-empty', json.item_count === 0);
        paint(json);
      })
      .catch(function () { window.location.reload(); });
  }

  /* E-G12 · cajón vacío: agrega 1 caja en compra única (sin selling_plan). */
  window.ssQuickAdd = function (el) {
    if (__adding || !el || el.disabled || el.getAttribute('aria-disabled') === 'true') return false;
    var variant = parseInt(el.dataset.variant, 10);
    if (!variant) return false;
    __adding = true;
    lock(el);
    postJSON('cart/add.js', {
      items: [{ id: variant, quantity: 1 }],
      sections: sectionIds(),
      sections_url: window.location.pathname
    })
      .then(function (json) { paint(json); })
      .catch(function (err) {
        unlock(el);
        showMsg(el, (err && err.message) || 'No se pudo agregar. Intenta de nuevo.');
      })
      .then(function () { __adding = false; });
    return false;
  };

  /* E-G04 · sustituye la única línea por el MIX con el MISMO modo de compra (pliego §4):
     1) /cart/change.js quantity 0 de la línea (por su key, que aún es válida: si se agregara primero el MIX,
        el bundle automático re-calcula la línea y su key cambia);
     2) /cart/add.js del MIX con el mismo selling_plan, pidiendo las secciones para re-pintar.
     Si el paso 2 falla, se re-agrega la línea original (misma variante y mismo plan) y se re-pinta:
     la clienta nunca se queda sin su caja ni pierde la suscripción. */
  window.ssSwapToMix = function (el) {
    if (__adding || !el || el.getAttribute('aria-disabled') === 'true') return false;
    var variant = parseInt(el.dataset.variant, 10);
    var key = el.dataset.lineKey;
    var orig = parseInt(el.dataset.origVariant, 10);
    var plan = el.dataset.plan ? parseInt(el.dataset.plan, 10) : 0;
    if (!variant || !key) return false;
    __adding = true;
    lock(el);
    var item = { id: variant, quantity: 1 };
    if (plan) item.selling_plan = plan;
    var removed = false;
    postJSON('cart/change.js', { id: key, quantity: 0 })
      .then(function () {
        removed = true;
        return postJSON('cart/add.js', {
          items: [item],
          sections: sectionIds(),
          sections_url: window.location.pathname
        });
      })
      .then(function (json) {
        paint(json);
        __adding = false;
      })
      .catch(function (err) {
        if (!removed) {
          unlock(el);
          showMsg(el, (err && err.message) || 'No se pudo cambiar. Intenta de nuevo.');
          __adding = false;
          return;
        }
        var back = { id: orig, quantity: 1 };
        if (plan) back.selling_plan = plan;
        (orig ? postJSON('cart/add.js', { items: [back] }) : Promise.resolve())
          .catch(function () { /* se re-pinta igual con el estado real del carrito */ })
          .then(function () { return refresh(); })
          .then(function () { __adding = false; });
      });
    return false;
  };

  /* D7 · SS_DRAWER_AUTOOPEN = false → renderContents de Dawn sin this.open() (regla del CLAUDE.md). */
  /* «Completa tu día» (ss-day.liquid, 6-oct). Solo compra única: −10 % con 2 cajas, −15 % con 3 o más
     («Bundle » / «Three bundle pack»). Lo marcado entra al carrito tras el alta del botón principal. */
  function dayFmt(c) {
    var v = Math.round(c) / 100;
    var whole = Math.abs(v % 1) < 0.005;
    return '$ ' + v.toLocaleString('es-MX', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
  }
  function dayOff(n) { return n >= 3 ? 15 : n >= 2 ? 10 : 0; }
  function dayTot(list) {
    var s = 0;
    list.forEach(function (p) { s += p; });
    return s * (100 - dayOff(list.length)) / 100;
  }
  function dayCalc(root) {
    if (!root) return;
    var rows = Array.prototype.slice.call(root.querySelectorAll('.ss-day__row'));
    var prices = [parseInt(root.dataset.curP, 10) || 0];
    rows.forEach(function (r) { if (r.dataset.on === 'true') prices.push(parseInt(r.dataset.p, 10) || 0); });
    var n = prices.length;
    var tot = dayTot(prices);
    var full = 0;
    prices.forEach(function (p) { full += p; });
    rows.forEach(function (r) {
      var b = r.querySelector('.ss-day__add');
      var line = r.querySelector('[data-ss-day-line]');
      var lineS = r.querySelector('[data-ss-day-line-sub]');
      if (!b || b.disabled || !line) return;
      var on = r.dataset.on === 'true';
      b.textContent = on ? 'Agregado' : 'Agregar';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var p = parseInt(r.dataset.p, 10) || 0;
      if (lineS) lineS.innerHTML = on ? '<strong>En tu entrega</strong>' : '<strong>+' + dayFmt(p * 0.95) + ' por entrega</strong> <s>' + dayFmt(p) + '</s>';
      if (on) { line.innerHTML = '<strong>En tu compra</strong>'; return; }
      var m = dayTot(prices.concat([p])) - tot;
      var d1 = dayOff(n + 1);
      line.innerHTML = '<strong>+' + dayFmt(m) + '</strong> <s>' + dayFmt(p) + '</s>' + (d1 > dayOff(n) ? '<span class="ss-day__pill">Todo baja a −' + d1 + ' %</span>' : '');
    });
    var subTot = 0;
    prices.forEach(function (p) { subTot += Math.round(p * 0.95); });
    dayBtn(root, n, tot, subTot);
    var svS = root.querySelector('[data-ss-day-save-sub]');
    if (svS) svS.textContent = n > 1
      ? 'Tu entrega: ' + n + ' cajas · ' + dayFmt(subTot) + ' cada vez · envío gratis'
      : '';
    var sv = root.querySelector('[data-ss-day-save]');
    if (sv) sv.textContent = n > 1
      ? 'Tu compra: ' + n + ' cajas · ' + dayFmt(tot) + ' · ahorras ' + dayFmt(full - tot)
      : 'Suma otra fórmula y todo baja 10 %.';
  }
  /* Botón principal + barra fija: con complementos marcados suman la caja de la página + lo marcado
     («Suscribirme · 2 cajas · $ 1,233.10 cada mes»). Base = el texto que ss-subscribe pone por modo/frecuencia. */
  var DAY_PRICE = /\$\s?[\d,]+(?:\.\d+)?/;
  function dayBtn(root, n, onceTot, subTot) {
    var uid = (root.id || '').replace(/^ss-day-/, '');
    var panel = root.closest('.ss-buy__panel') || document;
    var po = panel.querySelector('[data-ss-po]');
    var once = !po || po.getAttribute('data-mode') === 'once';
    var src = null;
    if (po) {
      src = once ? po.querySelector('[data-ss-row="once"]') : (po.querySelector('.ss-po__chip[aria-pressed="true"]') || po.querySelector('.ss-po__chip'));
    }
    var base = src && src.dataset.btn;
    var baseSt = src && src.dataset.stickyBtn;
    var add = n > 1 ? n + ' cajas · ' + dayFmt(once ? onceTot : subTot) : null;
    var btn = document.getElementById('ProductSubmitButton-' + uid);
    var lbl = btn && !btn.disabled ? (btn.querySelector('[data-ss-btn-label]') || btn.querySelector('span')) : null;
    if (lbl && base) lbl.textContent = add ? base.replace(DAY_PRICE, add) : base;
    var st = document.getElementById('ss-sticky-' + uid);
    var sb = st && st.querySelector('[data-ss-sticky-btn]');
    if (sb && baseSt) sb.textContent = add ? baseSt.replace(DAY_PRICE, add) : baseSt;
  }
  /* Al cambiar de modo o frecuencia ss-subscribe repinta el botón: se vuelve a sumar después. */
  (function dayWrapPlan() {
    if (typeof window.ssPlan !== 'function') { setTimeout(dayWrapPlan, 300); return; }
    if (window.ssPlan.__ssDay) return;
    var orig = window.ssPlan;
    window.ssPlan = function (el) {
      var r = orig.apply(this, arguments);
      var panel = el && el.closest('.ss-buy__panel');
      var root = panel && panel.querySelector('[data-ss-day]');
      if (root) dayCalc(root);
      return r;
    };
    window.ssPlan.__ssDay = true;
  })();
  window.ssDayToggle = function (el) {
    var row = el && el.closest('.ss-day__row');
    var root = el && el.closest('[data-ss-day]');
    if (!row || !root || el.disabled) return false;
    row.dataset.on = row.dataset.on === 'true' ? 'false' : 'true';
    dayCalc(root);
    return false;
  };
  /* Modo del panel: once → sin plan; sub → el selling_plan que manda el form principal (mismo plan en las 4). */
  function dayPlan(root) {
    var panel = root.closest('.ss-buy__panel') || document;
    var po = panel.querySelector('[data-ss-po]');
    if (!po || po.getAttribute('data-mode') === 'once') return { ok: true, plan: null };
    var sp = panel.querySelector('[data-ss-sp]');
    var plan = sp && !sp.disabled ? parseInt(sp.value, 10) : 0;
    return { ok: !!plan, plan: plan || null };
  }
  /* Tras el alta del botón principal (product-form): agrega los complementos marcados. */
  function dayAfterAdd(ev) {
    if (!ev || ev.source !== 'product-form' || __adding) return;
    var root = document.querySelector('[data-ss-day][data-cur-v="' + ev.productVariantId + '"]');
    if (!root) return;
    var pl = dayPlan(root);
    if (!pl.ok) return;
    var items = Array.prototype.filter.call(root.querySelectorAll('.ss-day__row'), function (r) { return r.dataset.on === 'true'; })
      .map(function (r) {
        var it = { id: parseInt(r.dataset.v, 10), quantity: 1 };
        if (pl.plan) it.selling_plan = pl.plan;
        return it;
      })
      .filter(function (i) { return i.id; });
    if (!items.length) return;
    var msg = root.querySelector('.ss-day__msg');
    __adding = true;
    postJSON('cart/add.js', { items: items, sections: sectionIds(), sections_url: window.location.pathname })
      .then(function (json) {
        return fetch(rootUrl() + 'cart.js?sections=' + encodeURIComponent(sectionIds().join(',')), { credentials: 'same-origin' })
          .then(function (r) { return r.json(); });
      })
      .then(function (json) {
        paint(json);
        Array.prototype.forEach.call(root.querySelectorAll('.ss-day__row'), function (r) { r.dataset.on = 'false'; });
        dayCalc(root);
      })
      .catch(function (err) {
        if (msg) { msg.textContent = (err && err.message) || 'No se pudieron agregar los complementos. Intenta de nuevo.'; msg.hidden = false; }
      })
      .then(function () { __adding = false; });
  }
  (function daySub() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, dayAfterAdd);
    } else {
      setTimeout(daySub, 300);
    }
  })();

  if (!SS_DRAWER_AUTOOPEN && window.customElements) {
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      if (!C || C.prototype.__ssNoOpen) return;
      C.prototype.__ssNoOpen = true;
      C.prototype.renderContents = function (parsedState) {
        var inner = this.querySelector('.drawer__inner');
        if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
        this.productId = parsedState.id;
        var self = this;
        this.getSectionsToRender().forEach(function (section) {
          var el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (!el || !parsedState.sections || !parsedState.sections[section.id]) return;
          el.innerHTML = self.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
        setTimeout(function () {
          var ov = self.querySelector('#CartDrawer-Overlay');
          if (ov) ov.addEventListener('click', self.close.bind(self));
        });
      };
    });
  }
})();



